// extracted by mini-css-extract-plugin
module.exports = {"fieldBox":"TextFieldWithFadeContent_fieldBox__1vSHz","fadeBox":"TextFieldWithFadeContent_fadeBox__8I5l3"};